import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Row } from '../Layout';
import { SharedProps } from './types';
import { FileType, getExtensionByType } from '../../utils/files';
import { round } from 'lodash';
import { match } from 'ts-pattern'

const FileRestrictionsTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.fontSizes.sm,
  color: theme.typography.body2.color,
}));

export type FileRestrictionDetailProps = Pick<
  SharedProps,
  'sizeRestriction' | 'supportedFormats'
>;

const FileRestrictionDetail: FC<FileRestrictionDetailProps> = ({
  sizeRestriction,
  supportedFormats = [],
}) => {
  const uniqueSupportedFormats = Array.from(
    new Set(
      supportedFormats.reduce<Array<string>>((acc, format) => {
        const extension = match(format)
          .with(FileType.DOC, () => getExtensionByType(FileType.DOCX))
          .with(FileType.Excel, () => getExtensionByType(FileType.ExcelAlt))
          .otherwise(() => getExtensionByType(format))
        return [...acc, extension.toUpperCase()]
      },
      []),
    ),
  );

  return (
    <Row justify="space-between">
      <FileRestrictionsTypography>
        {uniqueSupportedFormats.length ? (
          <>Supported formats: {uniqueSupportedFormats.join(', ')}</>
        ) : null}
      </FileRestrictionsTypography>

      {sizeRestriction ? (
        <FileRestrictionsTypography>
          Max. {round(sizeRestriction.value, 1)}
          {sizeRestriction.unit.toUpperCase()} per file
        </FileRestrictionsTypography>
      ) : null}
    </Row>
  );
};

export default FileRestrictionDetail;
